// Plays the operator chime when a new PENDING ticket arrives in the
// Emergency dashboard. Reuses the sound configuration the operator already
// manages from Configuración → Sonidos (volume, master toggle, custom audio
// per slot). If the operator has set a per-alert-type override (e.g. a
// distinctive klaxon for FIRE), that wins; otherwise we fall back to the
// shared "critical" slot used for SOS/Pánico.

import type { AlertType } from '@asi/shared';
import { useSettingsStore } from '@/stores/settings-store';
import { playBuiltinSound, playCustomAudio } from '@/utils/sound-player';

export function playNewAlertSound(type?: AlertType): void {
  const s = useSettingsStore.getState().sounds;
  if (!s.masterEnabled) return;
  const slot = (type ? s.byType[type] : undefined) ?? s.critical;
  if (!slot.enabled) return;
  if (slot.custom?.dataUrl) {
    playCustomAudio(slot.custom.dataUrl, s.volume);
  } else {
    playBuiltinSound(slot.builtin, s.volume);
  }
}
